<template>
<div class="financeData np-marketing-analysis">
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip content="活动的全部成交订单总金额" placement="top">
                            <div class="name">
                                <span>订单总金额</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{fianceinfo.totalordermoney}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="活动的佣金合计" placement="top">
                            <div class="name">
                                <span>佣金总金额</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{fianceinfo.totalbrokerage}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="活动的退款总金额" placement="top">
                            <div class="name">
                                <span>退款总金额</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{fianceinfo.refundmoney}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="活动商家实际收到的订单金额， 等于订单总金额-佣金总金额-支付手续费-退款金额" placement="top">
                            <div class="name">
                                <span>实收总金额</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{fianceinfo.hostincome}}</div>
                    </div>
                </div>
            </div>
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的订单金额'" placement="top">
                            <div class="name">
                                <span>时段订单金额</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{summaryinfo.allordermoney}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的返现金额'" placement="top">
                            <div class="name">
                                <span>时段佣金金额</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{summaryinfo.allorderbrokerage}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的实收金额'" placement="top">
                            <div class="name">
                                <span>时段实收金额</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{summaryinfo.allorderhostmoney}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">今天</el-button>
                    <el-button type="primary" @click="handleQuery(2)" :class="[param.timetype!=2?'is-disabled': '']">昨天</el-button>
                    <el-button type="success" @click="handleQuery(3)" :class="[param.timetype!=3?'is-disabled': '']">近7天</el-button>
                    <el-button type="warning" @click="handleQuery(4)" :class="[param.timetype!=4?'is-disabled': '']">近30天</el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div>
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
    <div class="list">
        <div class="dateTime blod"><span class="blod">{{summaryinfo.begindate}}</span> 至 <span class="blod">{{summaryinfo.enddate}}</span></div>
        <div class="result-list btn-operate-list bgc">
            <el-table :data="tableData" style="width: 100%" border>
                <el-table-column prop="date" label="时间" class-name="center"></el-table-column>
                <el-table-column prop="ordermoney" label="订单金额" class-name="center"></el-table-column>
                <el-table-column prop="orderbrokerage" label="佣金金额" class-name="center"></el-table-column>
                <el-table-column prop="orderhostmoney" label="实收金额" class-name="center"></el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getEventDataStatisticsByFinance, exportEventDataStatisticsByFinance, getDataSummary} from 'api/brandBusiness'
export default {
    name: 'financeData',
    data() {
        return {
            init: false,
            tableData: [],
            summaryinfo: {
                begindate: '',
                enddate: '',
                allavgviewcount: '0.00',
                alluviewcount: 0,
                allviewcount: 0
            },
            lineDatas: {id: 'financeData', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}'},
            date: [],
            datatype: 3, // 1用户统计 2订单统计 3财务统计 4分享统计 5裂变统计
            param: {
                timetype: 3, // 时间类型 0自定义 1今日 2昨日 3近7日 4近30日
                eventinnerid: '',
                begindate: '',
                enddate: ''
            },
            fianceinfo: {
                totalordermoney: '', // 订单总金额
                totalbrokerage: '', // 佣金总金额
                hostincome: '', // 实收总金额
                refundmoney: '' // 退款总金额

            }
        }
    },
    mounted() {
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begindate = this.date[0]
                this.param.enddate = this.date[1]
            }
            this.param.timetype = index
            this._getTotal()
        },
        getTotal(param) {
            this.param.eventinnerid = param.eventinnerid
            if (!this.init) {
                this._getDataSummary()
                this._getTotal()
            }
        },
        handleExport() {
            this.setLoading(true)
            exportEventDataStatisticsByFinance({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '财务数据' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getTotal() {
            this.setLoading(true)
            getEventDataStatisticsByFinance({
                data: this.param,
                success: data => {
                    this.tableData = data.data.datalist
                    this.summaryinfo = data.data.summaryinfo
                    this.lineDatas.xdata = data.data.datelist
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '订单金额',
                            color: '#1989FA',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.ordermoneylist
                        },
                        {
                            title: '佣金金额',
                            color: '#67C23A',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.orderbrokeragelist
                        },
                        {
                            title: '实收金额',
                            color: '#F56C6C',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.orderhostmoneylist
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getDataSummary() {
            getDataSummary({
                data: {eventinnerid: this.param.eventinnerid, datatype: this.datatype},
                success: data => {
                    this.init = true
                    this.fianceinfo = data.data.fianceinfo
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.financeData{

}
</style>
